import commonAct from '@/commonActionHandle.js';
import baseComponent from "@/scripts/baseComponent";
import gpuHubTransactionApi from '@/api/gpuHub/gpuHubTransaction';
import { debounce } from 'vue-debounce';
import { transactionStatusText } from "@/constant/vmMachineStatusConst";
import moment from "moment";
import { colorGpuNodeColor } from "@/constant/vmMachineStatusConst";
import { mapState } from "vuex";
export default {
    extends: baseComponent,
    props: {
        cardHeight: {
            type: String,
            default: 'height: calc(100dvh - 5.5rem);'
        },
        minInfo: {
            type: Boolean,
            default: false
        },
        ownedTarget: {
            type: String,
            default: null
        },
    },
    watch: {
        ownedTarget(newVal) {
            if (newVal !== null) this.getAllResult(1);
        }
    },
    data() {
        return {
            debounceFnc: null,
            debounceFilterFnc: null,
            elements: {
                querySearch: "",
                data: [],
                pagingItem: {
                    pageIndex: 1,
                    pageSize: 20,
                    numberOfPage: 1,
                    outRowsNumber: 0,
                    orderBy: "created_at",
                    directionSort: "desc"
                }
            },
            toogleFilter: false,
            elementDetail: null,
        };
    },
    filters: {
    },
    computed: {
        ...mapState({
            userInfo: state => state.auth.user,
            rolesInfo: state => state.auth.roles,
            staffsInfo: state => state.staffs,
            $emailAllowedChangeSource: (state) => state.emailAllowedChangeSource,
        }),
        defaultPagingItem() {
            return {
                pageIndex: 1,
                pageSize: 20,
                numberOfPage: 1,
                outRowsNumber: 0,
                orderBy: "created_at",
                directionSort: "desc"
            };
        },
        requestParam() {
            return {
                querySearch: this.elements.querySearch,
                pageSize: this.elements.pagingItem.pageSize,
            };
        },
    },
    created() {
        this.getAllResult(1);
        this.debounceFnc = debounce(() => {
            this.getAllResult(1);
        }, 1000);
    },
    methods: {
        getElementsList(pageNumber) {
            this.showLoading();
            gpuHubTransactionApi.getRechargeTestStatistics(pageNumber, this.requestParam, 8, 2020).then(response => {
                if (response.data && response.data.result === 0 && response.data.data !== null) {
                    this.elements.data = response.data.data.data;
                    this.elements.pagingItem = response.data.data.pagingItem;
                    this.hideLoading();
                }
                else {
                    this.elements.data = [];
                    this.elements.pagingItem = this.defaultPagingItem;
                    this.hideLoading();
                    if (response.data && response.data.message !== null && response.data.message !== '') {
                        commonAct.showError(response.data.message || this.$lang.common.error);
                    }
                }
            }).catch(error => {
                console.error(error);
                this.elements.data = [];
                this.elements.pagingItem = this.defaultPagingItem;
                this.hideLoading();
                commonAct.showError(error);

            });
        },
        getAllResult(pageNumber) {
            this.getElementsList(pageNumber);
        },
        pageClickHandle(pageNumber) {
            this.getAllResult(pageNumber);
        },
        refreshClick() {
            this.elements.querySearch = "";
            this.getAllResult(1);
        },
        onSearchInput(isDebounce) {
            if (isDebounce) {
                if (this.debounceFnc) this.debounceFnc();
            } else {
                this.getAllResult(1);
            }
        },
        viewDetailInfo(targetItem) {
            this.$set(this, "elementDetail", targetItem);
            this.$set(this, "rechargeModel", {
                pickedSource: 'gpuHub',
                amount: targetItem.amount,
                pointConversion: targetItem.transactionAmount,
                balance: targetItem.balance,
                provider: targetItem.transactionProvider,
                reason: targetItem.transactionProviderRefId,
                staffEmail: targetItem.currentStaff
            });
            this.$nextTick(() => {
                $("#detailModalInfo").modal({ backdrop: 'static', keyboard: true, });
            });
        },
        closeDetailInfo() {
            $("#detailModalInfo").modal("hide");
            this.$set(this, "elementDetail", null);
            this.$set(this, "rechargeModel", null);
        },
        exportData() {
            let host = process.env.VUE_APP_API_HOST.slice(0, -1);
            window.open(host + gpuHubTransactionApi.exportListTransaction(1, this.requestParam), '_blank');
        },
    }
}